import { render } from "./TabMenuNew.vue?vue&type=template&id=0a1b3168&ts=true"
import script from "./TabMenuNew.vue?vue&type=script&lang=ts"
export * from "./TabMenuNew.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__